import React from 'react'
import { gql } from 'apollo-boost'
import { Box, Button } from '@smooth-ui/core-sc'
import { Link } from 'react-router-dom'
import routeConfig from 'routeConfig'

import VideoImage from './VideoImage'
import { ListItemViev, ListWrapper, ListWrapperItem } from './Elements'
import { fixTitle } from 'helpers/entities'

export const fragment = gql`
  fragment PostList on RootQueryToPostConnection {
    nodes {
      id
      postId
      slug
      title
      content
      featuredImage {
        sourceUrl(size: THUMB)
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
`

const ListItem = ({ slug, featuredImage, backState, title, ...props }) => {
  const postTitle = fixTitle(title)
  const link = {
    pathname: `${routeConfig.post}/${slug}`,
    state: { postTitle, ...backState }
  }
  return (
    <ListItemViev
      to={link}
      image={
        featuredImage ? (
          <Link to={link}>
            <VideoImage image={featuredImage.sourceUrl} />
          </Link>
        ) : null
      }
      title={postTitle}
      {...props}
    />
  )
}

const ListView = ({
  nodes,
  pageInfo,
  baseUrl,
  after,
  backState,
  renderAfterContent
}) => {
  return (
    <>
      <ListWrapper>
        {nodes &&
          nodes.map(item => {
            return (
              <ListWrapperItem key={item.id}>
                <ListItem
                  {...item}
                  backState={backState}
                  after={renderAfterContent ? renderAfterContent(item) : null}
                />
              </ListWrapperItem>
            )
          })}
      </ListWrapper>
      <Box display="flex" justifyContent="center">
        {after && (
          <Button as={Link} to={baseUrl} mr={2}>
            Tilbake
          </Button>
        )}
        {pageInfo && pageInfo.hasNextPage && (
          <Button as={Link} to={`${baseUrl}/${pageInfo.endCursor}`}>
            Neste side
          </Button>
        )}
      </Box>
    </>
  )
}

export default ListView
